import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReservationsListPanel } from "../Reservations/components/ReservationsListPanel/ReservationsListPanel";
import PageContainer from "../../Components/PageContainer/PageContainer";
import { ControlledCustomSelect } from "../../Components/formComponents";
import { useNavigate, useParams } from "react-router-dom";
import { TABLES_LAYOUT_ROUTE, TABLES_ROUTE } from "./Tables.constants";
import { ICustomTableNode } from "../../Components/ReactFlowShapes/ReactFlowShapes.types";
import { ReactFlowShapesView } from "../../Components/ReactFlowShapes/ReactFlowShapesView";
import { TableBottom } from "./components/TableBottom";
import { IStoreState, useAppDispatch, useAppSelector } from "../../redux";
import {
  clearTablesLayoutStateSync,
  defaultTablesLayout,
  deleteLayoutWithCallbackAsync,
  fetchOutletSingleLayoutAsync,
  upsertSingleTableLayoutAsync,
} from "../../redux/tables";
import { useOutletContext } from "../../providers";
import TableLayoutTabs from "./TableLayoutTabs";
import { CreateNewLayoutButton } from "./dialogs/CreateNewLayoutButton";
import { PageLoader } from "../../Components/PageLoader/PageLoader";
import { LoadState } from "../../constants/enum";
import { StandardCard } from "../../Components/Card";

export const ViewSingleLayout: React.FC<{ onModeChange: () => void }> = ({
  onModeChange,
}) => {
  const { uuid: layoutUUID } = useParams<{ uuid?: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    outlet_details: { outlet_uuid, outlet_name },
  } = useOutletContext();

  const { data: tablesLayout, loading } = useAppSelector(
    (storeState: IStoreState) => storeState.tables.single_tables_layout
  );

  const [tablesList, setTablesList] = useState<ICustomTableNode[]>([]);

  const [searchFilter, setSearchFilter] = useState<
    ICustomTableNode["data"]["availability"] | "-1"
  >("-1");

  useEffect(() => {
    if (!layoutUUID) return;
    console.log("fetchOutletSingleLayoutAsync calling==>");
    dispatch(fetchOutletSingleLayoutAsync(layoutUUID));
  }, [layoutUUID]);

  useEffect(() => {
    setTablesList(tablesLayout.tables);
  }, [tablesLayout]);

  useEffect(() => {
    if (searchFilter.length > 0) {
      const newList = tablesLayout.tables.map((table) => {
        if (table.data.availability === searchFilter) {
          return table;
        }
        return {
          ...table,
          data: {
            ...table.data,
            disabled: true,
          },
        };
      });
      setTablesList(newList);
    }
  }, [searchFilter]);

  useEffect(() => {
    return () => {
      dispatch(clearTablesLayoutStateSync());
    };
  }, []);

  // const handleCreateNewLayout = () => {
  //   dispatch(upsertSingleTableLayoutAsync({
  //     ...defaultTablesLayout,
  //     outlet_uuid: outlet_uuid || "",
  //     outlet_name: outlet_name || ""
  //   })).then((res) => {
  //     if (res.meta.requestStatus === "fulfilled") {
  //       // window.location.reload()
  //     }
  //   });
  // }

  const handleDeleteLayout = () => {
    dispatch(
      deleteLayoutWithCallbackAsync({
        payload: tablesLayout,
        onCallback(isSuccess, activeLayout) {
          if (isSuccess) {
            if (activeLayout) {
              navigate(`${TABLES_ROUTE}/manage/${activeLayout}`);
            } else {
              window.location.reload();
            }
          }
        },
      })
    ).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        window.location.reload();
      }
    });
  };

  console.log("ViewSingleLayout ==>", tablesLayout);
  return (
    <PageLoader loading={LoadState.pending === loading}>
      <PageContainer title="Tables" description="Tables page">
        {tablesLayout.layout_uuid ? (
          <StandardCard
            heading={
              <>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Stack direction={"row"} alignItems="center" spacing={2}>
                    <Typography variant="h1" fontWeight={"bold"}>
                      Tables
                    </Typography>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={onModeChange}
                    >
                      Edit Layout
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="error"
                      onClick={handleDeleteLayout}
                    >
                      Delete Layout
                    </Button>
                  </Stack>

                </Stack>
              </>
            }
            rightHeading={
              
              <Stack direction={"row"} alignItems="center" spacing={2}>
              <TableBottom tables={tablesLayout.tables} />

              <ControlledCustomSelect
                options={[
                  { label: "None", value: "-1" },
                  { label: "Free", value: "FREE" },
                  { label: "Reserved", value: "RESERVED" },
                  { label: "Checked-In", value: "CHECKED_IN" },
                ]}
                value={searchFilter}
                onChange={(evt) =>
                  setSearchFilter(evt.target.value as any)
                }
                sx={{ minWidth: 120 }}
                fullWidth
                size="small"
              />
            </Stack>
            }
          >
            <Box
              sx={{
                height: "74vh",
              }}
            >
              <ReactFlowShapesView initialNodes={tablesList} />
            </Box>
          </StandardCard>
        ) : (
          // {tablesLayout.layout_uuid ?
          //   <Box>
          //     <Stack
          //       direction={"row"}
          //       alignItems={"center"}
          //       justifyContent={"space-between"}
          //     >
          //       <Stack direction={"row"} alignItems="center" spacing={2}>
          //         <Typography variant="h1" fontWeight={"bold"}>
          //           Tables
          //         </Typography>
          //         <Button variant="contained" size="small" onClick={onModeChange}  >Edit Layout</Button>
          //         <Button variant="contained" size="small" color="error"  onClick={handleDeleteLayout}  >Delete Layout</Button>
          //       </Stack>

          //       <Stack direction={"row"} alignItems="center" spacing={2}>
          //         <TableBottom tables={tablesLayout.tables} />

          //         <ControlledCustomSelect
          //           options={[
          //             { label: "None", value: "-1" },
          //             { label: "Free", value: "FREE" },
          //             { label: "Reserved", value: "RESERVED" },
          //             { label: "Checked-In", value: "CHECKED_IN" },
          //           ]}

          //           value={searchFilter}
          //           onChange={(evt) => setSearchFilter(evt.target.value as any)}
          //           sx={{ minWidth: 120 }}
          //           fullWidth size="small" />
          //       </Stack>
          //     </Stack>
          //     <Box sx={{
          //       height: "74vh"
          //     }}>
          //       <ReactFlowShapesView
          //         initialNodes={tablesList}
          //       />
          //     </Box>
          //   </Box>
          <Box
            sx={{
              minHeight: "80vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CreateNewLayoutButton onSuccess={() => window.location.reload()} />
          </Box>
        )}
      </PageContainer>
    </PageLoader>
  );
};
